// extracted by mini-css-extract-plugin
export default {"region-editor":"lsf-region-editor","region-editor_disabled":"lsf-region-editor_disabled","region-editor__wrapper":"lsf-region-editor__wrapper","region-editor__property":"lsf-region-editor__property","region-editor__text":"lsf-region-editor__text","region-editor__input":"lsf-region-editor__input","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630383281
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  